import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { AuthProvider } from './auth/AuthContext';
import { auth0Config } from './auth/auth0Api';

const history = createBrowserHistory();
const root = ReactDOM.createRoot(document.getElementById('root'));
if (!auth0Config.configured()) {
  root.render(<div style={{padding:24,fontFamily:'sans-serif'}}>Authentication configuration is incomplete.</div>);
} else {
  root.render(
    <React.StrictMode>
      <AuthProvider><HistoryRouter history={history}><App /></HistoryRouter></AuthProvider>
    </React.StrictMode>
  );
}
reportWebVitals();
